import { useEffect, useState } from "react";
import { admin, AiCall } from "../../api/client";
import { fmtDate, fmtNum, PageHeader } from "./common";
import { MessageInspector } from "./Messages";

export default function AiCalls() {
  const [status, setStatus] = useState("");
  const [purpose, setPurpose] = useState("");
  const [rows, setRows] = useState<AiCall[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [inspect, setInspect] = useState<string | null>(null);

  useEffect(() => {
    admin
      .aiCalls({ status: status || undefined, purpose: purpose || undefined, limit: 300 })
      .then(setRows)
      .catch((e) => setError(e.message));
  }, [status, purpose]);

  const totals = rows.reduce(
    (acc, r) => ({ in: acc.in + r.input_tokens, out: acc.out + r.output_tokens }),
    { in: 0, out: 0 },
  );

  return (
    <div className="page">
      <PageHeader
        title="AI calls"
        sub={`Every AI model request the worker made. Shown: ${fmtNum(rows.length)} calls · ${fmtNum(totals.in)} input / ${fmtNum(totals.out)} output tokens.`}
      />
      <div className="filter-bar">
        <select value={status} onChange={(e) => setStatus(e.target.value)} aria-label="Status">
          <option value="">Any status</option>
          <option value="ok">OK</option>
          <option value="error">Error</option>
          <option value="refusal">Declined</option>
        </select>
        <select value={purpose} onChange={(e) => setPurpose(e.target.value)} aria-label="Purpose">
          <option value="">Any source</option>
          <option value="email">Email</option>
          <option value="upload">Upload</option>
        </select>
      </div>
      {error && <div className="page-error">{error}</div>}
      <table className="data-table">
        <thead>
          <tr>
            <th>When</th>
            <th>Source</th>
            <th>Model</th>
            <th>Result</th>
            <th>Documents</th>
            <th style={{ textAlign: "right" }}>Tokens in / out</th>
            <th style={{ textAlign: "right" }}>Latency</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className={r.email_message_id ? "clickable" : undefined}
              onClick={() => r.email_message_id && setInspect(r.email_message_id)}>
              <td style={{ whiteSpace: "nowrap" }}>{fmtDate(r.created_at)}</td>
              <td>{r.purpose}</td>
              <td>{r.model}</td>
              <td style={{ color: r.status === "ok" ? undefined : "var(--danger)" }}>
                {r.status}{r.error ? `: ${r.error.slice(0, 100)}` : ""}
              </td>
              <td>{r.document_count}</td>
              <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                {fmtNum(r.input_tokens)} / {fmtNum(r.output_tokens)}
              </td>
              <td style={{ textAlign: "right" }}>{(r.latency_ms / 1000).toFixed(1)}s</td>
            </tr>
          ))}
        </tbody>
      </table>
      {inspect && <MessageInspector id={inspect} onClose={() => setInspect(null)} />}
    </div>
  );
}
